import { Component, HostListener, OnInit, signal } from '@angular/core';
import { MatMiniFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { VexColorScheme } from '@vex/config/vex-config.interface';
import { VexConfigService } from '@vex/config/vex-config.service';

/**
 * Botão flutuante para alternar dark/light mode.
 * Também pode ser ativado via atalho de teclado: Ctrl+Shift+D
 *
 * Posicionado no canto inferior direito da tela.
 * Integra-se com o VexConfigService para manter o estado sincronizado
 * com o restante da aplicação.
 */
@Component({
  selector: 'app-dark-mode-toggle',
  standalone: true,
  imports: [MatMiniFabButton, MatIcon, MatTooltip],
  template: `
    <button
      mat-mini-fab
      color="primary"
      [matTooltip]="isDark() ? 'Modo claro (Ctrl+Shift+D)' : 'Modo escuro (Ctrl+Shift+D)'"
      (click)="toggle()"
      aria-label="Alternar dark mode"
    >
      <mat-icon>{{ isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>
  `,
  styles: [
    `
      :host {
        position: fixed;
        bottom: 1.25rem;
        right: 1.25rem;
        z-index: 9999;
        opacity: 0.75;
        transition: opacity 150ms ease;
      }

      :host:hover {
        opacity: 1;
      }
    `,
  ],
})
export class DarkModeToggleComponent implements OnInit {
  isDark = signal(false);

  constructor(private readonly configService: VexConfigService) {}

  ngOnInit(): void {
    // Lê o estado inicial que o VexConfigService já aplicou no body
    this.isDark.set(document.body.classList.contains(VexColorScheme.DARK));
  }

  @HostListener('document:keydown.control.shift.d', ['$event'])
  onKeyboardToggle(event: any): void {
    event.preventDefault();
    this.toggle();
  }

  toggle(): void {
    const newScheme = this.isDark() ? VexColorScheme.LIGHT : VexColorScheme.DARK;
    this.isDark.set(newScheme === VexColorScheme.DARK);
    this.configService.updateConfig({ style: { colorScheme: newScheme } });
  }
}
